import { useVersionCheck } from "../../hooks/useVersionCheck.jsx";
import { getEnv } from "../../env.js";
import { PORTAL } from "../portals.js";

/**
 * Reusable component that generates version text using environment variables and version check hook
 *
 * @param {object} props
 * @param {string} props.separator - Text to separate parts (default: " | ")
 */
export default function VersionText({ separator = " | " }) {
  const appVersion = useVersionCheck();

  // the deployed build is only relevant outside of production
  const appEnv = getEnv("VITE_APP_ENV") || "production";
  const branch = import.meta.env.VITE_APP_BRANCH;
  // a release build's "branch" is really the version tag (e.g. "v1.2.3"),
  // which just repeats the version already shown - skip it in that case
  const isVersionTag = branch === `v${appVersion}`;
  const buildParts =
    appEnv !== "production"
      ? [
          import.meta.env.VITE_APP_TAG,
          import.meta.env.VITE_APP_COMMIT,
          isVersionTag ? null : branch,
          import.meta.env.VITE_APP_BUILT_AT,
        ].filter(Boolean)
      : [];
  const buildSuffix = buildParts.length ? ` (${buildParts.join(" · ")})` : "";

  // both portal containers share one runtime config, so each has its own title key
  const appTitle =
    import.meta.env.VITE_PORTAL === PORTAL.KUNDENPORTAL
      ? getEnv("VITE_KUNDENPORTAL_TITLE")
      : getEnv("VITE_APP_TITLE");

  const versionText = `${appTitle}${separator}Version ${appVersion}${buildSuffix}${separator}${getEnv("VITE_TENANT_LABEL")} ${getEnv("VITE_TENANT_LABEL2")}`;

  return versionText;
}
